  <div [className]="'loginForgotPassword'">
    <form class="form-signin text-center" (ngSubmit)="forgotPassword()">
      <div>
        <img class="mb-4" src="assets/images/JT_signin_Logo.gif" alt="Jobtrain Login" width="200" data-testid="img-default-logo">
      </div>
      <div #container></div>
      <h4 class="h3 mb-3 font-weight-normal" data-testid="txt-reset-password">
        {{ 'Login.ResetPassword' | translate }}
      </h4>
      <p data-testid="p-reset-password">
        {{'Login.ResetPasswordText'|translate}}
      </p>

      <span id="MainContent_diverror" style="display:block; position:relative; padding-bottom:15px; height:30px; width:100%; color:Red;margin-bottom:15px">{{error}}</span>

      

      <input type="text" id="inputEmail" data-testid="txt-enter-email-address" class="form-control" placeholder="{{'Common.Enteremailaddress' | translate}}" #userName="ngModel" name="userName" asp-for="Username" [(ngModel)]="user.userName" required autofocus>
      <br />
      <button data-testid="btn-reset-password" class="btn btn-lg btn-primary btn-block forgotPassword btn_resetpassword" type="submit">{{ 'Login.ResetPassword' | translate }}</button>

      <p data-testid="p-copyright">&copy; {{ 'Login.Footer' | translate }}</p>
    </form>
  </div>


